import PortfolioTemplate from './PortfolioTemplate';

export default PortfolioTemplate;
